import { render, staticRenderFns } from "./school_id_required.vue?vue&type=template&id=6ecb8b38&"
import script from "./school_id_required.vue?vue&type=script&lang=js&"
export * from "./school_id_required.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports